module.exports = __webpack_public_path__ + "static/img/default_avatar.89845f4e.jpg";